import { PaymentMethodTypes } from '@accedo/one-plugin-sdk';

import { CoreResponseType, SubmitResponse, TFormData } from '#/client/models';
import { Form } from '#/components/Form/Form';
import {
  formDataToCreditCard,
  getPaymentInputFields,
} from '#/plugins/paywall/components';
import { noop } from '#/service/utils';
import { tb } from '#/store/translation/translation.store';

import { createBasicFormConfig } from '../Form/Form.utils';
import { PaymentCardLogos } from './PaymentCardLogos';
import { PaymentFormProps } from './types';

export const PaymentCardForm = ({
  onPurchase,
  isPaymentDetailsRequired,
  buyButtonText = 'web.iap.purchase.button',
  disclaimerText = 'web.iap.disclaimer',
  setIsDisabled = noop,
  onSuccess,
  onFailure,
}: PaymentFormProps) => {
  const submitForm = async (formData: TFormData) => {
    const card = formDataToCreditCard(formData);
    setIsDisabled(true);

    return onPurchase(
      { card, paymentMethod: { type: PaymentMethodTypes.CreditCard } },
      buyButtonText
    )
      .then<SubmitResponse>(() => {
        onSuccess();

        return { _meta: { type: CoreResponseType.SUCCESS } };
      })
      .catch<SubmitResponse>((err) => {
        onFailure(err);

        return {
          _meta: { type: CoreResponseType.ERROR, ignoreError: true },
        };
      })
      .finally(() => setIsDisabled(false));
  };

  const inputGroups = createBasicFormConfig(
    'payment',
    getPaymentInputFields(isPaymentDetailsRequired),
    {
      submit: {
        textKeyPath: buyButtonText,
        onClick: submitForm,
        disclaimer: tb(disclaimerText),
      },
    }
  );

  return (
    <>
      <PaymentCardLogos />
      <Form inputGroups={inputGroups} />
    </>
  );
};
